import { YII_URL } from '../utilities/globals';
const ApiURLs = {
	baseURL: YII_URL,
	publicFilesURL: '',
	/*UserLogin: {
		href: '/auth/authenticate',
		method: 'post',
		requires: ['username', 'password', 'remember'],
	},
	ReadUserBatch: {
		href: '/glifos/api/checkin/batch',
		method: 'post',
	},
	UploadFile: {
		href: '/file/upload',
		method: 'post',
	},
	dowloadFile: {
		href: '/glifos/file/download/',
		method: 'get',
	},
	getFileMetadata:{
		href: '/lot/lot-data',
		method:'get'
	},*/
	getNode: {
		href: '/website/node/{%:node%}',
		method: 'get',
	},
	getItem: {
		href: '/website/item/{%:isadg%}',
		method: 'get',
	},
	getItemResume: {
		href: '/website/itemresume/{%:isadg%}',
		method: 'get',
	},
	getCollection: {
		href: '/website/collection/{%:isadg%}',
		method: 'get',
	},
	getCollectionImages: {
		href: '/website/collectionimages/{%:isadg%}',
		method: 'get',
	},
	getCollectionImage: {
		href: '/website/collectionimage/{%:fileid%}',
		method: 'get',
	},
	getAgency: {
		href: '/website/agency/{%:isadg%}',
		method: 'get',
	},
	getAgencySolr: {
		href: '/search/collections',
		method: 'get',
		params: ['repository'],
	},
	getCollectionInfoSolr: {
		href: '/search/collections',
		method: 'get',
		params: ['repository', 'isadg'],
	},
	getImageFile: {
		href: '/website/imageid/{%:isadg%}',
		method: 'get',
	},
	getInventory: {
		href: '/website/get-inventory',
		method: 'get',
	},
};

export default ApiURLs;
